import { Component, OnInit, inject } from '@angular/core';
import { AuthViewEnum } from './enums/auth-step-enum';
import { UsernameFormPresenterComponent } from './presenters/username-form-presenter/username-form-presenter.component';
import { IUserNameFormOutput } from '../models/username-form-output-model';
import { SigninService } from '@shared/service/http_services/signin.service';
import { CheckUserStateBody, userRegisterModel } from '@shared/model/customerModels/register-view-model';
import { catchError, finalize, iif, of, switchMap, tap } from 'rxjs';
import { UserStateEnum } from '@shared/enums/user-state.enum';
import { BaseComponent } from '@shared/components/base/base.component';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';
import { OtpVerificationPresenterComponent } from './presenters/otp-verification-presenter/otp-verification-presenter.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ISignInRequest } from '@shared/model/sign-in.model';
import { RegisterFormPresenterComponent, RegisterStepEnum } from './presenters/register-form-presenter/register-form-presenter.component';
import { IAuthDialogInput } from '../models/auth-dialog-input.model';
import { Router } from '@angular/router';
import { htmlUrls } from '@shared/utils/router-paths';
import { CustomerAggrigatorService } from '@shared/service/http_services/customerAggrigator.service';
import { LoginFormPresenterComponent } from './presenters/login-form-presenter/login-form-presenter.component';
import { ForgetPasswordPresenterComponent } from './presenters/forget-password-presenter/forget-password-presenter.component';
import { ForgetPasswordModel, ReqForgetPassword } from '@shared/model/forgetPassword-model';
import { ForgetFlowStepEnum } from './enums/forget-flow-step-enum';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { IGoogleAuthResponse } from '../models/google-auth-response.model';
import { NgClass } from '@angular/common';
import { CustomersService } from '@shared/service/http_services/customer.service';

@Component({
  selector: 'app-auth-container-dialog',
  imports: [
    UsernameFormPresenterComponent,
    OtpVerificationPresenterComponent,
    RegisterFormPresenterComponent,
    LoginFormPresenterComponent,
    ForgetPasswordPresenterComponent,
    NgClass
  ],
  templateUrl: './auth-container-dialog.component.html',
  styleUrl: './auth-container-dialog.component.scss'
})
export class AuthContainerDialogComponent extends BaseComponent implements OnInit {
  private signInService = inject(SigninService);
  private cusstomerService = inject(CustomersService);
  private customerAggrigatorService = inject(CustomerAggrigatorService);

  private dialogRef = inject<MatDialogRef<AuthContainerDialogComponent>>(MatDialogRef);
  private router = inject(Router);
  private socialAuthService = inject(SocialAuthService);
  private dialogInput = inject<IAuthDialogInput>(MAT_DIALOG_DATA);


  authView: AuthViewEnum = AuthViewEnum.userName; //? current view of the container
  forgetFlowStep: ForgetFlowStepEnum = ForgetFlowStepEnum.userName; //? current step of forget pass flow
  authStepEnum = AuthViewEnum; //? auth view enum
  initialData: IUserNameFormOutput | null = null; //? user username and it's type(email or phone)
  userExists = false; //? if the user exists after user state check
  routes = htmlUrls; //? urls constant
  usernamecheckLoading = false; //? username check loading
  isUsernameDuplicated = false; //? is username duplicated
  verificationCode!: number | string; //? user's entered otp code
  googleData: IGoogleAuthResponse | null = null; //?data loaded from google
  getOtpLoading = false;
  verifyLoading = false;
  registerationLoading = false;
  loginLoading = false;
  confirmPasswordLoading = false;
  signUpPerformed = false;
  registerStep: RegisterStepEnum = RegisterStepEnum.ProfileCompletion;

  ngOnInit(): void {
    const sub = this.handleGoogleAuthResponse().subscribe();
    this.subscriptions.push(sub);
  }

  // * after filling the first input(phone or email)
  checkUserState(data: IUserNameFormOutput) {
    this.getOtpLoading = true;
    this.initialData = data;
    const body: CheckUserStateBody = { email: null, user: { phoneNumber: null, username: '' } };
    if (this.initialData.type == 'email')
      body.email = this.initialData.userName;
    else
      body.user.phoneNumber = this.initialData.userName;
    this.signInService.checkUserExist(body).pipe(
      switchMap(res => {
        if (!res.hasError) {
          if (res.result === UserStateEnum.exist) {
            this.userExists = true;
            return this.getOtp();
          }
          else {
            this.userExists = false;
            return this.requestForVerification();
          }
        }
        else return of(null);
      })

    ).subscribe(() => this.getOtpLoading = false);
  }

  // * if the user exists
  getOtp() {
    return this.signInService.getOtp(this.initialData?.userName!).pipe(
      tap(res => {
        if (res.result)
          this.snackbarService.openSnackbar(SnackBarTypes.success, res.result);
        this.authView = this.authStepEnum.otp_verification;
      })
    );
  }

  // * if the user doesnt exist
  requestForVerification() {
    return iif(
      () => this.initialData!.type == 'phone',
      this.signInService.requestForPhoneNumberVerification(this.initialData?.userName!),
      this.signInService.requestForEmailVerification(this.initialData?.userName!)
    ).pipe(
      tap(res => {
        if (res.result)
          this.snackbarService.openSnackbar(SnackBarTypes.success, res.result);
        this.authView = this.authStepEnum.otp_verification;
      })
    );
  }

  // * verify the entered code and change step(registeration) or call connect api(user exists)
  verifyCode(code: number) {
    this.verifyLoading = true;
    const apiStream$ = this.initialData?.type == 'email' ?
      this.signInService.emailVerification(code, this.initialData?.userName!) :
      this.signInService.phoneNumberVerification(code, this.initialData?.userName!)
    apiStream$.pipe(
      switchMap(res => {
        if (!res.hasError) {
          if (this.authView == AuthViewEnum.forget_pass) {
            this.forgetFlowStep = ForgetFlowStepEnum.setPassword;
            return of(null);
          }
          else {
            if (this.userExists) {
              const input = this.createSignInObject(this.initialData?.userName!, code, true, 'otp_token', 'otpToken', code, this.initialData?.userName!)
              return this.signIn(input);
            }
            else {
              this.verificationCode = code;
              this.authView = AuthViewEnum.registeration;
              this.registerStep = RegisterStepEnum.ProfileCompletion
              return of(null);
            }
          }

        }
        else {
          this.snackbarService.openSnackbar(SnackBarTypes.error, 'کد وارد شده صحیح نیست');
          return of(null);
        }
      })
    ).subscribe(() => this.verifyLoading = false);
  }

  // * create signin required data object
  createSignInObject(username: string, password: string | number, isOtp: boolean, grandType: 'password' | 'otp_token' | 'google_oauth', input_type: 'googleAuth' | 'otpToken' | null, verificationCode: string | number, input: string) {
    return {
      username,
      password,
      isOtp,
      grandType,
      input_type,
      verificationCode,
      input
    } as ISignInRequest;
  }


  // * call signin api
  signIn(credentials: ISignInRequest) {
    this.loginLoading = true;

    return this.signInService.signin(credentials).pipe(
      switchMap(res => {
        this.registerationLoading = false;
        if (res) {
          return this.userStateService.initializeUserState();
        }
        else return of(false);
      }),
      switchMap(() => {
        this.navigateToDestination();
        this.loginLoading = false;
        this.closeDialog();
        return of(false);
      }),
      // switchMap(() => this.cusstomerService.getInviteCode()),
      finalize(() => {
        this.loginLoading = false;
        this.closeDialog();
      }),
      catchError(err => {
        console.log(err);
        return of(null);
      })
    );
  }

  // * login with username and password
  loginWithPassword(credentials: ISignInRequest) {
    this.signIn(credentials).pipe(
      catchError(() => {
        return of(null);
      })
    ).subscribe();
  }

  signup(data: userRegisterModel) {
    this.registerationLoading = true;
    let input = '';
    if (this.googleData) {
      input = this.googleData.email;
    }
    else {
      input = this.initialData?.userName!;
    }
    this.signUpPerformed = true;

    return this.signIn({ grandType: 'register_auth', input_type: this.googleData ? 'googleAuth' : 'otpToken', verificationCode: data.code, name: data.user?.firstname, username: data.user?.username, input }).subscribe();
  }

  // ? handle navigation after authentication
  navigateToDestination() {
    const { redirectPath } = this.dialogInput;
    if (this.signUpPerformed) {
      if (this.googleData)
        this.router.navigate([htmlUrls.onboarding], { queryParams: { step: 0, avatar: this.googleData.photoUrl } });
      else
        this.router.navigate([htmlUrls.onboarding], { queryParams: { step: 0 } });
    }
    else {
      if (redirectPath) {
        this.router.navigateByUrl(redirectPath);
      }
    }
  }

  checkUserName(username: string) {
    this.customerAggrigatorService.checkDuplicateUsername(username).subscribe(res => {
      this.usernamecheckLoading = false;
      if (!res.hasError) {
        if (res.result) {
          this.isUsernameDuplicated = true;
        }
        else {
          this.isUsernameDuplicated = false;
        }
      }
    });
  }

  changeUserLoading() {
    this.usernamecheckLoading = true
  }

  getForgetPassCode(data: IUserNameFormOutput) {
    this.getOtpLoading = true;
    this.initialData = data;
    const body: ReqForgetPassword = new ReqForgetPassword();
    if (this.initialData.type == 'email')
      body.email = this.initialData.userName;
    else
      body.phoneNumber = this.initialData.userName;
    return this.signInService.forgetPassword(body).subscribe(res => {
      this.getOtpLoading = false;
      if (!res.hasError) {
        this.forgetFlowStep = ForgetFlowStepEnum.verification;
      }
      if (res.result && !res.hasError) {
        this.snackbarService.openSnackbar(SnackBarTypes.success, res.result.toString());
      }
      else if (res.hasError && res.message == 'try after 2 minutes') {
        this.snackbarService.openSnackbar(SnackBarTypes.warning, 'لطفاً بعد از 2 دقیقه اقدام کنید.');
      }
      else {
        this.snackbarService.openSnackbar(SnackBarTypes.warning, 'این شماره پیش از این ثبت‌نام نشده است.');
      }
    });
  }

  changePassword(data: ForgetPasswordModel) {
    this.confirmPasswordLoading = true;
    this.signInService.resetPassword(data).subscribe(res => {
      this.confirmPasswordLoading = false;
      if (!res.hasError) {
        this.snackbarService.openSnackbar(SnackBarTypes.success, `رمز شما با موفقیت تغییر کرد`);
        this.resetFlow();
      }
    });
  }


  handleGoogleAuthResponse() {
    return this.socialAuthService.authState.pipe(
      switchMap((data: IGoogleAuthResponse) => {
        if (data) {
          const body: CheckUserStateBody = { email: data?.email, user: { phoneNumber: null, username: '' } };
          return this.signInService.checkUserExist(body).pipe(
            switchMap(res => {
              if (!res.hasError) {
                if (res.result === UserStateEnum.exist) {
                  this.userExists = true;
                  return this.signIn({ grandType: 'register_auth', isOtp: false, username: data?.email, verificationCode: data.idToken, input_type: 'googleAuth' });
                }
                else {
                  this.userExists = false;
                  this.googleData = data;
                  this.authView = AuthViewEnum.registeration;
                  return of(null);
                }
              }
              else return of(null);
            })
          );
        }
        return of(null);
      })
    );
  }

  setAuthView(step: AuthViewEnum) {
    this.forgetFlowStep = ForgetFlowStepEnum.userName;
    this.authView = step;
  }

  resetFlow() {
    this.authView = AuthViewEnum.userName;
    this.initialData = null;
    this.signUpPerformed = false;
  }


  closeDialog() {
    this.dialogRef.close();
  }

  // ? handel back action
  back() {
    switch (this.authView) {
      case this.authStepEnum.registeration:
        if (this.registerStep === RegisterStepEnum.UsernameSetup) {
          this.registerStep = RegisterStepEnum.ProfileCompletion;
        } else {
          this.authView = this.authStepEnum.userName;
        }
        break;
      // case this.authStepEnum.userName:
      //   this.authView = this.authStepEnum.slider;
      //   break;
      case this.authStepEnum.otp_verification:
        this.authView = this.authStepEnum.userName;
        break;
      case this.authStepEnum.login:
        this.authView = this.authStepEnum.userName;
        break;
      case this.authStepEnum.forget_pass:
        if (this.forgetFlowStep === ForgetFlowStepEnum.verification || this.forgetFlowStep == ForgetFlowStepEnum.setPassword) {
          this.forgetFlowStep = ForgetFlowStepEnum.userName;
        }
        else {
          this.authView = this.authStepEnum.userName;
        }
        break;
      default:
        this.authView = this.authStepEnum.slider;
        break;
    }
  }

  changeRegisteraionStep(step: RegisterStepEnum) {
    this.registerStep = step
  }

}
